import {
  ChipCellComponent,
  ComponentCellType,
  WcgChipType,
  WcgTableRow,
} from '@wcg/frontend-framework';
import { CONFIG_SUBMISSIONS_COLUMNS } from '../constants';

export function transformSubmissionsData(
  data: any[],
  dateFormatFn: (dateStr: string) => string,
): WcgTableRow[] {
  if (!CONFIG_SUBMISSIONS_COLUMNS?.length) return [];

  return data.map((item) => ({
    ...CONFIG_SUBMISSIONS_COLUMNS.reduce(
      (acc, col) => {
        if (col.columnKey) {
          acc[col.columnKey] = getCellConfig(col.columnKey, item, dateFormatFn);
        }
        return acc;
      },
      {} as Record<string, unknown>,
    ),
  })) as WcgTableRow[];
}

function getCellConfig(
  key: string,
  item: any,
  dateFormatFn: (dateStr: string) => string,
) {
  const configMap: Record<string, unknown> = {
    label: {
      componentConfig: {
        routerLink: `/admin/configurations/submission-type/${item.id}/${item.entity_type}`,
      },
      cellData: item.label || item.name,
      componentType: ComponentCellType.Link,
    },
    name: {
      cellData: item.name,
      componentType: 'default',
    },
    entity_type: {
      cellData: item.entity_type,
      componentType: 'default',
    },
    origin: {
      cellData: item.origin || '',
      componentType: 'default',
    },
    num_document_types: {
      cellData: item.num_document_types || 0,
      componentType: 'default',
    },
    iris_routing_group_name: {
      cellData: item.iris_routing_group_name || '',
      componentType: 'default',
    },
    iris_envelope_type: {
      cellData: item.iris_envelope_type || '',
      componentType: 'default',
    },
    order: {
      cellData: item.order || 0,
      componentType: 'default',
    },
    created_dt: {
      cellData: item.created_dt
        ? new Date(item.created_dt).toLocaleDateString()
        : '',
      componentType: 'default',
    },
    updated_dt: {
      cellData: item.updated_dt
        ? new Date(item.updated_dt).toLocaleDateString()
        : '',
      componentType: 'default',
    },
    configuration_created_dt: {
      cellData: item.configuration_created_dt
        ? dateFormatFn(item.configuration_created_dt)
        : '',
      componentType: 'default',
    },
    configuration_updated_dt: {
      cellData: item.configuration_updated_dt
        ? dateFormatFn(item.configuration_updated_dt)
        : '',
      componentType: 'default',
    },
    configuration_published_dt: {
      cellData: item.configuration_published_dt
        ? dateFormatFn(item.configuration_published_dt)
        : '',
      componentType: 'default',
    },
    configuration_status: {
      componentType: ChipCellComponent,
      componentConfig: {
        chipType:
          item.configuration_status === 'published'
            ? WcgChipType.SUCCESS
            : WcgChipType.NEUTRAL,
      },
      cellData:
        item.configuration_status === 'published' ? 'Published' : 'Draft',
    },
    // Legacy mappings for backward compatibility
    routing_group: {
      cellData: item.routing_group || item.iris_routing_group_name || '',
      componentType: 'default',
    },
    envelope_type: {
      componentType: 'default',
      cellData: item.envelope_type || item.iris_envelope_type || '',
    },
  };
  return configMap[key] || {};
}
